import { IcoGift } from "~/icons";

const Tag = () => {
  return (
    <div className="bg-pink py-0.5 px-1.5 text-white absolute left-2 top-2 rounded-lg flex items-center font-semibold text-[15px] leading-5">
      <IcoGift className="mr-1" />
      Free
    </div>
  );
};

Tag.displayName = "Tag";
export default Tag;
